import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', {
  // Nur die Theme-Wahl persistieren; cmdKeyPressed & Co. bleiben transient.
  persist: { pick: ['theme'] },
  state: () => ({
    cmdKeyPressed: false,
    lastVisitedFolderId: null,
    // 'light' | 'dark' | null. null = noch keine Nutzerwahl -> aus dem OS
    // (prefers-color-scheme) initialisieren.
    theme: null,
    // Laufender Upload (z. B. aus dem MediaModal) für die untere
    // Fortschrittsanzeige (analog zum Drag&Drop-Upload).
    uploading: false,
    uploadProgress: 0,
  }),
  actions: {
    startUpload() {
      this.uploadProgress = 0
      this.uploading = true
    },
    setUploadProgress(percent) {
      this.uploadProgress = Math.max(0, Math.min(100, percent || 0))
    },
    endUpload() {
      this.uploading = false
      this.uploadProgress = 0
    },
    getCurrentBreakpoint(width) {
      if (width < 640) return 'xs'
      if (width < 768) return 'sm'
      if (width < 1024) return 'md'
      if (width < 1280) return 'lg'
      if (width < 1536) return 'xl'
      return '2xl'
    },
    /**
     * Initialisiert das Theme. Ohne persistierte Nutzerwahl greift die
     * OS-Einstellung (prefers-color-scheme); danach wird die persistierte
     * Wahl übernommen. In beiden Fällen wird die .dark-Klasse gesetzt.
     */
    initTheme() {
      if (this.theme === null) {
        const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches
        this.theme = prefersDark ? 'dark' : 'light'
      }
      this.applyTheme()
    },
    /**
     * Setzt das Theme explizit und wendet es an.
     * @param {'light'|'dark'} value
     */
    setTheme(value) {
      this.theme = value
      this.applyTheme()
    },
    /** Wechselt zwischen hell und dunkel. */
    toggleTheme() {
      this.setTheme(this.theme === 'dark' ? 'light' : 'dark')
    },
    /** Spiegelt den State auf <html class="dark">. */
    applyTheme() {
      document.documentElement.classList.toggle('dark', this.theme === 'dark')
    },
  },
})
